const breadcrumbsHome = { name: 'Home', pathName: '/home' }
const breadcrumbsEmpresa = { name: 'Empresa', pathName: null, action: 'empresa' }
const breadcrumbsMaria = { name: 'Decomposição', pathName: null, action: 'decomposicao' }

export default [
  {
    path: '/empresa',
    component: () => import('@/modules/empresa/views/pages/Empresa.vue'),
    children: [
      {
        path: 'faturamento',
        component: () => import('@/modules/empresa/faturamento/views/pages/Faturamento.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsEmpresa,
            {
              name: 'Faturamento',
              pathName: null,
            },
          ],
          title: 'Faturamento',
          pagePermission: 'empresa/faturamento',
        },
      },
      {
        path: 'faturamento/diario/:mes',
        component: () => import('@/modules/empresa/faturamento/views/pages/FaturamentoDiario.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsEmpresa,
            {
              name: 'Faturamento',
              pathName: '/empresa/faturamento',
            },
            {
              name: 'Diário',
              pathName: null,
            },
          ],
          title: 'Faturamento diário',
          pagePermission: 'empresa/faturamento',
        },
      },
      {
        path: 'desempenho',
        component: () => import('@/modules/empresa/desempenho/views/pages/Desempenho.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsEmpresa,
            {
              name: 'Desempenho',
              pathName: null,
            },
          ],
          title: 'Desempenho',
          pagePermission: 'empresa/desempenho',
        },
      },
      {
        path: 'decomposicao',
        component: () => import('@/modules/empresa/decomposicao-faturamento/views/pages/DecompositionRevenues.vue'),
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsMaria,
            {
              name: 'Decomposição de faturamento',
              pathName: null,
            },
          ],
          title: 'Decomposição de faturamento',
          pagePermission: 'empresa/decomposicao',
        },
      },
      {
        path: 'faturamento-incremental/:analysisId?',
        component: () => import('@/modules/empresa/dre/views/pages/index.vue'),
        name: 'Faturamento incremental',
        meta: {
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsEmpresa,
            {
              name: 'Faturamento incremental',
              pathName: null,
            },
          ],
          title: 'Faturamento incremental',
          pagePermission: 'empresa/faturamento',
        },
      },
    ],
  },
]
